import { Component } from '@angular/core';
import { DocumentManagerCoreComponent } from '../document-manager-core/document-manager-core.component';

@Component({
    selector: 'app-document-manager-general-settings-desktop',
    templateUrl: './document-manager-general-settings-desktop.component.html',
    styleUrls: ['./document-manager-general-settings-desktop.component.scss'],
    standalone: false
})
export class DocumentManagerGeneralSettingsDesktopComponent extends DocumentManagerCoreComponent {}
